import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
  input: {
    backgroundColor: 'white',
  },
  shrink: {
    padding: '0 5px',
    backgroundColor: 'white',
  },
  notchedOutline: {
    borderRadius: 0,
  },
});

export default makeStyles(styles);
